<template>
<div>

    <productColorListModal v-if="promoProductModal" v-bind:productId="productId"  v-bind:promoId="promoId" v-bind:price="priceList" @close="promoProductModal=false"  ></productColorListModal>
  
    <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

    <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">
  
    <table class="table table-hover table-sm table-bordered table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col"></th>
        <th scope="col">#</th>
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">LINEA</th>
        <th scope="col">CODICE</th>
        <th scope="col">CATEGORIA</th>                
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th class="text-right" scope="col">PREZZO DI LISTINO</th>
        <th scope="col">PREZZO PROMO </th>
        <th scope="col">SCONTO PROMO </th>
        <th scope="col">COLORE(i)</th>       
      </tr>
    </thead>
    <tbody>
      
      <tr data-toggle="tooltip" title="doppio click colori e sconto" @dblclick="setProductColorListModal(index)" class="pointer" v-for="(item, index) in filteredItems" :key="index">
        <td>
           <input  class="pointer" type="checkbox"  v-model.number="item.selected">
           
          </td> 
        <td>{{index+1}}</td>
        <td>{{item.productId}}</td>
        <td>{{item.brand}}</td>
        <td>{{item.line}}</td>
        <td><strong>{{item.sku}}</strong>
        </td>
        <td>{{item.category}}</td>        
        
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td class="text-right">{{fmt1(item.price)}} </td>
         
        <td>{{item.promoPrice}}</td>
        <td>{{item.promoDiscount}}</td>
        <td>{{item.colorList}}</td>
       
      </tr> 
      
      
    </tbody>
    
  </table>
 </div>



<label for="filter">
  <i class="fas fa-filter mr-2 mt-3" aria-hidden="true"></i>
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
<div class="mt-2">

<button v-if="show_btn" @click="deleteCB()" type="button"   class="btn btn-outline-danger float-left mt-1 mb-2 mr-4 ml-4">                    
          ELIMINA SELEZIONE PRODOTTI
          <i class="fas fa-trash ml-2 mr-2" aria-hidden="true"></i>
</button>


<button @click="setSelection(1)" type="button"   class="btn btn-outline-secondary float-left mt-1 mb-2 mr-2">                    
        SELEZIONA TUTTO
          <i class="fas fa-edit ml-2 mr-2" aria-hidden="true"></i>
</button>


<button @click="setSelection(0)" type="button"   class="btn btn-outline-secondary float-left mt-1 mb-2 mr-2">                    
        DESELEZIONA TUTTO
          <i class="far fa-edit ml-2 mr-2" aria-hidden="true"></i>
</button>
</div>

<form class="form-inline float-right" v-on:submit.prevent="setConfirmBox()">

  <div class="form-group mx-sm-3 ">
    <label  for="Input7"><strong>PREZZO DA APPLICARE</strong></label>
    <input required :min="0"  :step="0.01" type="number" class="form-control ml-3" v-model="discountedPrice" >
    
  </div>
  <div class="form-group mx-sm-3 ">
    <label  for="Input7"><strong>% SCONTO DA APPLICARE</strong></label>
    <input required :min="0" type="number" class="form-control ml-3" v-model="discount" >
    
  </div>
  <button type="submit" :disabled="bt_spinner == true"  class="btn btn-primary ">
    <i class="far fa-edit  mr-2" aria-hidden="true"></i>
   APPLICA PROMO
    <span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
   </button>


</form>

    <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-primary float-right">
          OK</button>
      </template>    
    </confirm-box>


     <confirm-box v-if="cbReset.show">     
      <template v-slot:header>
        <strong>{{cbReset.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cbReset.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cbReset.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="houseKeeping()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>    

    <confirm-box v-if="cbConfirm.show">     
      <template v-slot:header>
        <strong>{{cbConfirm.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cbConfirm.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cbConfirm.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="saveData()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>    




</div>
</template>
<script>

import api                    from "@/api";
import alertBox               from '@/components/common/AlertBox.vue'
import confirmBox             from '@/components/common/ConfirmBox.vue'

import fmt                    from '@/components/mixins/fmt.js'
import productColorListModal  from '@/components/frontOffice/PromoProductColorListModal.vue';


import {mapGetters }    from 'vuex';

export default {
  props      : ['promoId','products','show_btn'],
  mixins :[fmt],

  components  : {
    alertBox,  confirmBox,  productColorListModal
    
},
  data() {
    return {
    
      items             : [],
      promoProductModal : false,
    
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },

    

    bt_spinner             : false, 
    discount               : 0 ,
    filterKey              : '' ,
    cb                     : {title : '',msg1 : '',show:false},
    cbReset                : {title : '',msg1 : '',show:false},
    cbConfirm              : {title : '',msg1 : '',show:false},
    promo                  : {},
    
    
    colorList              : [],
    productId              : 0,
    priceList              : 0,
    discountedPrice        : 0
    
    
   
    
     
    }
  },
  computed :{
   
     ...mapGetters(['company']),
     
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },

  created: function() 
  {
    this.items = this.products
    
  },
  methods: {
    

    setConfirmBox()
    {
      
      if(this.discount > 0)
      {
        this.cbConfirm.title = 'CONFERMI PROMO SCONTO '  +  this.discount +  '%  PRODOTTI SELEZIONATI ?'
      }
      else
      {
        this.cbConfirm.title = 'CONFERMI PROMO PREZZO '  +  this.fmt1(this.discountedPrice) +  ' € PRODOTTI SELEZIONATI ?'
      }
      this.cbConfirm.show = true
    },
    deleteCB()
    {
      if(this.items.length>0)
      {
        this.cbReset.title = 'ELIMINA SELEZIONE PRODOTTI'
        this.cbReset.msg1 = 'Si desidera eliminare la selezione prodotti ?'
        this.cbReset.show = true
        
      }
    },
    houseKeeping()
    {
      this.items=[],
      this.cbReset.show=false,
      this.$emit('reset')
      this.$emit('close')
    },

    
    
    setProductColorListModal(index)
    {
      
        this.productId =  this.filteredItems[index].productId
        this.priceList =  this.filteredItems[index].price

        this.promoProductModal = true
      
    },
    setSelection(set)
    {
        this.items.forEach(item=>{
          item.selected = set
      })
    },

    async saveData() {
    
      this.cbConfirm.show = false
      this.cb.title = ''
      this.bt_spinner = true
      
      let data = {}
      data.body = []
      let price
      let discount

      let colorIds = []
      this.filteredItems.forEach(item=>{
        if(item.selected==1)
        {          
          colorIds = item.colorIds.split('|')                    
          colorIds.forEach(colorId=>{                      
            price = this.discountedPrice
            discount = this.discount
            data.body.push({'productId':item.productId,'promoId':this.promoId,'discount':this.discount,'colorId':colorId,'price':this.discountedPrice})  
          })
          
        }
      })  
      data.price = price
      data.discount = discount
      const sp = {'sp':'spUpdatePromoProduct'}      
      const json    = Object.assign(data, sp)

         await api.post(json).then(res => {
                    
          if(res.status==200)
            {              
              this.cb.title = "PROMO PRODOTTI"
              this.cb.msg1  = "Registrazione effettuata."
              this.cb.show  = true
                  
            }
          
          else
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.bt_spinner = false
      
    }

  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}

.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}
 



.table {
  border-collapse: separate;
}

.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
   
    
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;
    
    
    position     : sticky;
   
    top          : 0;
    z-index      : 10;

 }


 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 18px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}


</style>